import { FinanceValueObjectsContactTaxIdTypeEnum } from 'generated/resources/graphql'

import Select from 'modules/core/components/Select'
import { useMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

type TaxIdTypeOption = {
  value: FinanceValueObjectsContactTaxIdTypeEnum
  label: string
}

interface SelectorProps {
  selectedTaxIdType?: FinanceValueObjectsContactTaxIdTypeEnum
  error?: string
  mandatory?: boolean
  readOnly?: boolean
  onSelectTaxIdType: (selected?: FinanceValueObjectsContactTaxIdTypeEnum) => void
}

const getTaxIdTypeOptionLabel = (taxIdType: FinanceValueObjectsContactTaxIdTypeEnum) => {
  switch (taxIdType) {
    case 'vat_number':
      return i18n.t('finance.contacts.contact_form.fields.tax_id_type.vat_number')
    case 'passport':
      return i18n.t('finance.contacts.contact_form.fields.tax_id_type.passport')
    case 'official_id':
      return i18n.t('finance.contacts.contact_form.fields.tax_id_type.official_id')
    case 'other_proof_document':
      return i18n.t('finance.contacts.contact_form.fields.tax_id_type.other_proof_document')
    case 'residence_certificate':
      return i18n.t('finance.contacts.contact_form.fields.tax_id_type.residence_certificate')
    case 'not_registered':
      return i18n.t('finance.contacts.contact_form.fields.tax_id_type.not_registered')
    default:
      return taxIdType satisfies never
  }
}

export const ContactTaxIdTypeSelector = ({
  selectedTaxIdType,
  error,
  mandatory,
  readOnly,
  onSelectTaxIdType,
}: SelectorProps) => {
  const taxIdTypeOptions = useMemo(
    (): TaxIdTypeOption[] => [
      {
        value: 'vat_number',
        label: getTaxIdTypeOptionLabel('vat_number'),
      },
      {
        value: 'passport',
        label: getTaxIdTypeOptionLabel('passport'),
      },
      {
        value: 'official_id',
        label: getTaxIdTypeOptionLabel('official_id'),
      },
      {
        value: 'residence_certificate',
        label: getTaxIdTypeOptionLabel('residence_certificate'),
      },
      {
        value: 'other_proof_document',
        label: getTaxIdTypeOptionLabel('other_proof_document'),
      },
      {
        value: 'not_registered',
        label: getTaxIdTypeOptionLabel('not_registered'),
      },
    ],
    []
  )

  const handleOnChange = (value: string) => {
    onSelectTaxIdType(taxIdTypeOptions.find((option) => option.value === value)?.value)
  }

  return (
    <Select
      none={i18n.t('common.select')}
      readonly={readOnly}
      mandatory={mandatory}
      label={i18n.t('finance.contacts.contact_form.fields.tax_id_type.label')}
      options={taxIdTypeOptions}
      onChange={handleOnChange}
      value={selectedTaxIdType ? selectedTaxIdType : undefined}
      error={error}
    />
  )
}
